import { Alert, Typography } from "@mui/material"
import { ScheduleItem } from "routes/schedule/tree/schedules/scheduleItem"
import { getRegimeLocation } from "routes/facilities/facilities-search-location.mjs"

export function FacilitiesSearchResult({ item, last }) {
    const { schedule, treeItem } = item
    const location = getRegimeLocation(treeItem)

    if (!treeItem) {
        return (
            <Alert severity="warning" sx={{ mb: 1 }}>
                {schedule.label} is no longer available through this share link.
            </Alert>
        )
    }

    return (
        <ScheduleItem
            schedule={schedule}
            last={last}
            extra={
                !!location && (
                    <Typography variant="caption" color="text.secondary" data-cy="search-result-location">
                        {location}
                    </Typography>
                )
            }
        />
    )
}
